import { Component, EventEmitter, Input, Output } from '@angular/core'
import { OneTimeAccessToken, OneTimeAccessTokenFromJSON } from 'elements-sdk'
import { OneTimeAccessTokenModalComponent } from 'main/components/oneTimeAccessTokenModal.component'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { IdentityService, ParametersService } from 'main/module'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { SharingService } from 'media.sharing/services/sharing.service'
import { MediaPermissionModalComponent } from 'media.permissions'

@Component({
  selector: 'shared-link',
  templateUrl: './sharedLink.component.pug',
  styleUrls: ['./sharedLink.component.scss'],
})
export class SharedLinkComponent {
  @Input() token: OneTimeAccessToken
  @Input() includeName = false
  @Input() includeContentLink = false
  @Input() showCreatedAt = false
  url: string
  title: string
  @Output('deleted') onDelete = new EventEmitter<void>()

  usedTimesPlural = `Used {count, plural,
    one{once}
    other{{count} times}
  }`

  permissionsPlural = `{count, plural,
    one{One permission}
    other{{count} permissions}
  }`

  constructor (
    public identity: IdentityService,
    private translate: TranslateService,
    private api: APIService,
    private parameters: ParametersService,
    private mediaPermissions: MediaPermissionsService,
    private ngbModal: NgbModal,
    private sharing: SharingService,
  ) { }

  async ngOnInit () {
    const prefix = `${location.protocol}//${location.host}`
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    this.url = `${this.parameters.values.externalUrl || prefix}/auth/fast-lane/${this.token.token}`
    this.title = this.sharing.getTitleForToken(this.token, { includeName: this.includeName })
  }

  ngOnChanges () {
    if ('created_at' in this.token) {
      this.token = OneTimeAccessTokenFromJSON(this.token)
    }
  }

  canEdit () {
    return this.identity.hasPermission('media:roots:manage') && this.token.mediaRootPermissions.length === 1 && !this.token.isEasySharingForBundle && !this.token.isEasySharingForDirectory
  }

  canDelete () {
    return this.identity.hasPermission('users:manage') || this.token.createdBy?.id === this.identity.user?.id
  }

  showActivityLog () {
    const m = this.ngbModal.open(OneTimeAccessTokenModalComponent)
    m.componentInstance.token = this.token
    m.result.catch(() => null)
  }

  async edit () {
    const perms = await this.api.mediaLibrary.getAllMediaRootPermissions({
      isTemporaryForToken: this.token.id,
    })
    if (!perms.length) {
      return
    }
    const existingPermission = perms[0]
    const m = this.ngbModal.open(MediaPermissionModalComponent)
    m.componentInstance.permission = existingPermission
    let permission = await m.result.catch(() => null)
    if (!permission) {
      return
    }
    permission = await this.api.mediaLibrary.patchMediaRootPermission({
      id: permission.id,
      mediaRootPermissionPartialUpdate: permission,
    })
    this.ngOnChanges()
  }

  async delete () {
    this.onDelete.emit()
    await this.api.auth.deleteAccessToken(this.token)
  }
}
